import TableCellDefault, { tableCellClasses } from "@mui/material/TableCell";
import TableRowDefault from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";

export { default as Table } from "@mui/material/Table";
export { default as TableBody } from "@mui/material/TableBody";

export { default as TableContainer } from "@mui/material/TableContainer";
export { default as TableHead } from "@mui/material/TableHead";

export const TableRow = styled(TableRowDefault)(() => ({
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
	"&:nth-of-type(odd)": {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
	},
}));

export const TableCell = styled(TableCellDefault)(({ theme }) => ({
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: "transparent",
		color: theme.palette.common.white,
	},
}));
